// extracted by mini-css-extract-plugin
module.exports = {"box":"Breadcrumbs_box__3k9X9","fragment":"Breadcrumbs_fragment__1MgSp","link":"Breadcrumbs_link__17cDm"};